import { saveMovedPoint } from '../functions'
import {
  emphasise, mitigate,
  hideDateSelection, showDoneEditingBox, showLineAttributes
} from '../helperFunctions'
import { drawnSource } from './layers'
import { updateMeasureTooltip, hideMeasureTooltip } from './measure'
import { moveTabToOperations, showToolbar } from '../navigation'
import { createAdvice, setToday } from '../populateForms'
import {
  collection, CURRENT_GEOTYPE, debug, i18n, locallyAr5,
  minDrawingZoom, maxEditResolution, minZoom
} from '../storage'
import { map } from './tools'
import { editableRegion } from '../server'

import Collection from 'ol/Collection'
import Feature from 'ol/Feature'
import MultiLineString from 'ol/geom/MultiLineString'
import MultiPoint from 'ol/geom/MultiPoint'
import Point from 'ol/geom/Point'
import Polygon from 'ol/geom/Polygon';
import Draw from 'ol/interaction/Draw'
import Modify from 'ol/interaction/Modify'
import Snap from 'ol/interaction/Snap'
import Overlay from 'ol/Overlay'
import { Circle, Fill, Stroke, Style } from 'ol/style'

// Currently drawn feature.
// @type {Feature}
export let sketch;

let drawnCoordinates = [];

// The draw tooltip element.
let drawTooltipElement;

// Overlay to show the draw message.
export let drawTooltip;

export let drawInteraction;
let snappingGeometry, snap, modify;

let cancelledDrawing = false;
export const setCancelledDrawing = b => cancelledDrawing = b;

export const updateSnappingGeometry = (geometry) => { // MultiPoint
  if (geometry) {
    snappingGeometry = geometry;
    // const sgf = new Feature(geometry);
    const sgf = new Feature(new MultiPoint(geometry.coordinates));
    // const egenSource = new VectorSource({ features: [sgf] });
    const activeDrawing = (snap && snap.getMap());
    if (activeDrawing) map.removeInteraction(snap);
    snap = new Snap({
      // source: drawnSource,
      // source: vectorLayer.getSource(),
      // source: egenSource,
      features: new Collection([sgf]),
      // features: new Collection([]),
      edge: false,
      pixelTolerance: 18
    });
    if (activeDrawing) map.addInteraction(snap);
  } else if (!snap) snap = new Snap({ source: drawnSource, pixelTolerance: 18 });
  // snap.on('snap', e => console.log(e.vertex));
};

// Double click when less than two points will lead to saving window:
const dbl = (evt) => {
  if (debug < 15) console.log('double');
  if (degenerateLine()) return;
  const ff = drawnSource.getFeatures();
  const lastDrawing = ff[ff.length - 1].getGeometry().getCoordinates();
  if (!lastDrawing[0].length && ff.length > 1) { // same as clicking on Ferdig:
    drawInteraction.finishDrawing();
    enoughDrawings();
    map.removeOverlay(drawTooltip);
    drawnSource.removeFeature(ff[ff.length - 1]);
  }
};

const enoughDrawings = () => {
  if (!cancelledDrawing) { // else do not save
    map.addInteraction(modify);
    // map.addInteraction(snap); // does not work, event when leaving f1
    showLineAttributes();
    if (locallyAr5) document.getElementById('toolbarWindow').hidden = false;
    else {
      const ibdlar = document.getElementById('info-box-drawnline-attributes-row');
      ibdlar.appendChild(createAdvice('verifisering'));
      const linje = (CURRENT_GEOTYPE === 'line');
      if (linje) ibdlar.appendChild(createAdvice('endreLinje'));
      const flate = (CURRENT_GEOTYPE === 'surface');
      if (flate) ibdlar.appendChild(createAdvice('endreGrense'));
    }
  }
  setTimeout(removeDrawing, 400);
  // map.getView().setMinZoom(minZoom);
};

const onDrawEnd = (e) => {
  const g = e.feature.getGeometry();
  const cc = g.getCoordinates();
  const p = new Polygon([cc]);
  if (debug < 16) console.log('drawend:', cc);
  const linestring = (g.getType() === 'LineString');
  const startingPoint = drawnSource.getFeatureById('p1');
  if (startingPoint) drawnSource.removeFeature(startingPoint);
  // const spv = vectorLayer.getSource().getFeatureById('p1');
  // if (spv) vectorLayer.getSource().removeFeature(spv);
  const multi = linestring && document.getElementById('multi').checked;
  if (multi) {
    drawnCoordinates = [];
    // multilinestring.appendLineString(g);
    // console.log('streker', multilinestring.getLineStrings().length);
    ferdigBtn.classList.remove('hidden'); // dblclick
  } else enoughDrawings();
  const f = g.getFirstCoordinate(), l = g.getLastCoordinate();
  const closed = f[0] === l[0] && f[1] === l[1];
  if (locallyAr5 && linestring && closed) updateMeasureTooltip(p);
};

export function addDrawing(type) {
  // console.log('addDrawing');
  if (debug < 14)
    document.getElementById('multiple').hidden = (type !== 'LineString');
  map.getView().setMinZoom(minDrawingZoom);
  drawInteraction = new Draw({
    source: drawnSource,
    type: type
  });

  // Reset array
  drawnCoordinates = [];

  // Create tooltip and check for click events
  createDrawingTooltip();
  map.on('singleclick', clickMoveHandler);
  map.on('dblclick', dbl);

  // Add drawing interaction:
  map.addInteraction(drawInteraction);
  // ...and snap interaction:
  if (snap) map.addInteraction(snap);
  // else console.log('Undefined snap');
  // ...and modify interaction on drawend:
  modify = new Modify({ source: drawnSource });
  // map.addInteraction(modify);

  // Save drawn feature once we start drawing:
  drawInteraction.on('drawstart', (evt) => {
    if (debug < 14) console.log('drawstart');
    cancelledDrawing = false;
    sketch = evt.feature;
    const f1 = new Feature({
      geometry: new Point(sketch.getGeometry().getCoordinates()[0])
    });
    f1.setId('p1');
    f1.setStyle(new Style({
      image: new Circle({
        fill: new Fill({ color: 'rgba(255,255,255,0.4)' }),
        stroke: new Stroke({ color: '#339900', width: 2 }),
        radius: 10
      })
    }));
    drawnSource.addFeature(f1); // to be visible
    if (snap && snap.getMap()) snap.addFeature(f1); // to be able to snap to
    // vectorLayer.getSource().addFeature(f1);
  });

  // Remove drawing interaction and overlay, when drawing is done:
  // drawInteraction.un('drawend', onDrawEnd);
  drawInteraction.on('drawend', onDrawEnd);
}

const onPointMoved = (e) => {
  drawnSource.clear(); // only one drawn point visible
  // Copy properties from original (invisible) to moved point:
  collection.features.forEach(f => {
    if (f.properties['invisible']) {
      Object.keys(f.properties).forEach(key => {
        if (key !== 'geometry') e.feature.set(key, f.properties[key]);
      });
    }
  });
  if (!locallyAr5) setToday(document.querySelector('#info-box-object-attributes-row'));
  showDoneEditingBox();
};

export const addMovePoint = () => {
  drawInteraction = new Draw({
    source: drawnSource,
    type: 'Point'
  });
  // Add drawing interaction
  map.addInteraction(drawInteraction);
  // Remove drawing interaction and overlay, when drawing is done:
  // drawInteraction.un('drawend', onPointMoved);
  drawInteraction.on('drawend', onPointMoved);
};

export const removeDrawing = () => {
  // console.log('removeDrawing');
  // multilinestring = new MultiLineString([]); // empty for next drawing.
  map.removeInteraction(drawInteraction);
  map.removeInteraction(snap);
  // Snap looses added feature sgf after canceling or rehabilitating drawings:
  updateSnappingGeometry(snappingGeometry);
  map.removeOverlay(drawTooltip);
  map.un('singleclick', clickMoveHandler);
  map.un('dblclick', dbl);
};

// Delete the last drawn point when drawing a line
export function deleteLastDrawnPoint() {
  if (debug < 14) console.log('number of points', drawnCoordinates.length);
  if (drawnCoordinates.length > 1) {
    drawInteraction.removeLastPoint();
    drawnCoordinates.pop();
    const doubleLast = drawnCoordinates.concat(drawnCoordinates.slice(-1));
    const sg = sketch.getGeometry();
    // sg.setCoordinates(sg.getCoordinates().slice(0, -1));
    sg.setCoordinates(doubleLast); // do not show last point
    hideMeasureTooltip();
  } else if (drawnCoordinates.length === 1) {
    // drawInteraction.finishDrawing();
    drawInteraction.removeLastPoint();
    drawnCoordinates = [];
    // sketch.getGeometry().setCoordinates([]);
    const ff = drawnSource.getFeatures();
    drawnSource.removeFeature(ff[ff.length - 1]);
    // ff[ff.length - 1].getGeometry().setCoordinates([]);
  } else { // 0 points
    // drawInteraction.removeLastPoint(); // did nothing
    const ff = drawnSource.getFeatures();
    // ff[ff.length - 1].getGeometry().getCoordinates().pop();
    const lf = ff[ff.length - 1];
    drawnCoordinates = lf.getGeometry().getCoordinates();
    drawInteraction.extend(lf);
    // drawnCoordinates.pop();
    // drawnCoordinates = sketch.getGeometry().getCoordinates();
    // drawnSource.clear();
    // ff[ff.length - 1].setGeometry(null);
    // ff[ff.length - 1].getGeometry().setCoordinates([]);
    drawnSource.removeFeature(lf);
    // drawnCoordinates.forEach((c, i) => {
    //   if (i === 0) drawInteraction.startDrawing_({ coordinate: c });
    //   else drawInteraction.addToDrawing_({ coordinate: c })
    // });
    // ff[ff.length - 1].setGeometry(drawnCoordinates[0]);
    const doubleLast = drawnCoordinates.concat(drawnCoordinates.slice(-1));
    sketch.getGeometry().setCoordinates(doubleLast); // do not show last point
  }
  showHideDrawingTooltip();
}

export const rehabilitateDrawing = () => {
  // console.log('rehabilitate');
  const ff = drawnSource.getFeatures();
  const oldDrawing = ff[ff.length - 1];
  drawnCoordinates = oldDrawing.getGeometry().getCoordinates();
  const gt = oldDrawing.getGeometry().getType();
  // console.log('geometry type:', gt);
  // drawnSource.clear();
  drawnSource.removeFeature(oldDrawing);
  if (gt !== 'Point') drawInteraction.extend(oldDrawing);
  map.removeInteraction(modify);
  map.addInteraction(drawInteraction);
  if (snap) map.addInteraction(snap);
  map.addOverlay(drawTooltip);
  map.on('singleclick', clickMoveHandler);
  map.on('dblclick', dbl);
  // drawInteraction.setActive(true);
  // if (gt !== 'Point') { drawInteraction.removeLastPoint(); }
  showHideDrawingTooltip();
  $("#info-box-text").show();
  hideDateSelection(); // when drawing polygons or points
  if (locallyAr5) document.getElementById('twdStep1').hidden = false;
  $("#info-box-text-no-action").hide(); // when drawing linestrings
};

// Creates a tooltip when drawing
function createDrawingTooltip() {
  if (drawTooltipElement) {
    drawTooltipElement.parentNode.removeChild(drawTooltipElement);
  }
  drawTooltipElement = document.createElement('div');
  drawTooltipElement.id = 'ferdig_angre';
  const ok = document.createElement('button');
  ok.id = 'ferdigBtn';
  ok.className = 'btn green darken-1 small-button hidden';
  if (locallyAr5) ok.classList.remove('green', 'darken-1');
  ok.innerHTML = '<u>F</u>erdig';
  ok.title = 'Hurtigtast F';
  ok.style.margin = '4px';
  // ok.style.backgroundColor = 'rgb(0, 150, 0)';
  const ko = document.createElement('BUTTON');
  ko.id = 'cancelDrawingBtn';
  ko.className = 'btn red darken-2 small-button';
  if (locallyAr5) ko.classList.remove('red', 'darken-2');
  ko.innerHTML = 'Avbryt';
  ko.title = 'Hurtigtast Esc';
  ko.style.margin = '4px';
  // ko.style.backgroundColor = 'rgb(230, 0, 0)';
  drawTooltipElement.appendChild(ko);
  drawTooltipElement.appendChild(ok);
  const card = document.getElementById('drawingCard');
  // const parent = document.body;
  const parent = card.getElementsByClassName('card-action')[0];
  parent.appendChild(drawTooltipElement);

  drawTooltip = new Overlay({
    // element: drawTooltipElement,
    offset: [15, 0],
    positioning: 'center-left'
  });

  ok.onclick = () => {
    const ff = drawnSource.getFeatures();
    const lastDrawing = ff[ff.length - 1].getGeometry().getCoordinates();
    // const l0 = lastDrawing[0];
    // console.log(
    //   'lastDrawing', lastDrawing, l0 instanceof Array, Array.isArray(l0),
    //   Object.prototype.toString.call(l0), l0.length, l0.constructor === Array
    // );
    // drawnSource does not update until drawend, that means we can use
    // lastDrawing to check whether to drawend and save or just drawend.
    drawInteraction.finishDrawing();
    // if (multilinestring.getLineStrings().length > 0) enoughDrawings();
    // if (ff.length > 1 && lastDrawing.length > 1) enoughDrawings();
    // if (lastDrawing.length > 1) enoughDrawings();
    // if (lastDrawing[0].length && lastDrawing.length > 1) enoughDrawings();
    enoughDrawings();
    map.removeOverlay(drawTooltip);
    hideMeasureTooltip();
  };

  ko.onclick = () => {
    cancelledDrawing = true;
    drawInteraction.finishDrawing();
    map.removeOverlay(drawTooltip);
    deleteLastDrawnPointBtn.classList.add('hidden');
    moveTabToOperations();
    map.getView().setMinZoom(minZoom); // drawend is not triggered if empty draw
    showToolbar('none');
    hideMeasureTooltip();
  };

  map.addOverlay(drawTooltip);
}

const degenerateLine = (stillDrawing) => {
  if (debug < 15) drawingStat();
  const sc = sketch.getGeometry().getCoordinates();
  const numberOfPoints = sc.length - (stillDrawing ? 1 : 0);
  const p = sc[0];
  // Do not use evt.coordinate, can be different close to a snapping point:
  const q = sc[sc.length - 1];
  const coinciding = (p[0] === q[0] && p[1] === q[1]);
  if ((numberOfPoints === 2) && coinciding) {
    if (debug < 15) console.log('Degenerate line!');
    if (!stillDrawing) rehabilitateDrawing();
    drawInteraction.removeLastPoint();
    return true;
  }
  return false;
};

// Handles click so we can update the draw tooltip
const clickMoveHandler = (evt) => {
  if (evt.dragging) return;
  if (debug < 15) console.log('single');
  if (degenerateLine(true)) return;
  // console.log('cursor', evt.coordinate); // wrong as drawn coordinate on snap
  // console.log('snapped/drawn/used', sketch.getGeometry().getCoordinates().at(-1));
  const cc = sketch.getGeometry().getCoordinates();
  // drawnCoordinates.push(evt.coordinate);
  drawnCoordinates.push(cc[cc.length - 1]);
  drawTooltip.setPosition(evt.coordinate);
  // move it away from the direction you are drawing
  const p = drawnCoordinates;
  const l = p.length;
  if (l > 2) {
    if (p[l-1][0] - p[l-2][0] > 0) {
      drawTooltip.setOffset([-85, 0]);
    } else {
      drawTooltip.setOffset([15, 0]);
    }
  }
  showHideDrawingTooltip();
};

const drawingStat = () => {
  console.log('--- stat ---');
  const ff = drawnSource.getFeatures();
  console.log('drawnCoordinates', drawnCoordinates);
  console.log('sketch', sketch.getGeometry().getCoordinates());
  console.log('drawnSource has', ff.length, 'features (= number of lines)');
  ff.forEach((f, i) => {
    console.log('drawnSource f', i, f.getGeometry().getCoordinates());
  });
  console.log('Last line has', drawnCoordinates.length, 'points');
};

const uniqueCoordinates = (cc) => {
  const l = cc.length;
  if (l > 1) {
    const last = cc[l - 1];
    const secondLast = cc[l - 2];
    const sameX = (last[0] === secondLast[0]);
    const sameY = (last[1] === secondLast[1]);
    if (sameX && sameY) return cc.slice(0, -1);
  }
  return cc;
}

function showHideDrawingTooltip() {
  const ff = drawnSource.getFeatures();
  if (debug < 14) drawingStat();
  // sketch is strange (double point at the end while adding):
  // const currentStroke = sketch.getGeometry().getCoordinates().slice(0, -1);
  // const currentStroke = drawnCoordinates;
  const currentStroke = uniqueCoordinates(sketch.getGeometry().getCoordinates());
  const cl = currentStroke.length;
  // const dl = drawnCoordinates.length;
  // const currentStrokeLength = Math.max(dl, cl);
  const currentStrokeLength = cl;
  const numberOfLines = ff.length;
  const validSingleLine = (numberOfLines === 1) && (currentStrokeLength > 1);
  const validMultipleLines = (numberOfLines > 1) && (currentStrokeLength > 1);
  const f1 = ff[0];
  const firstLineLength = f1 ? f1.getGeometry().getCoordinates().length : 0;
  // Only display the tooltip when user has created a line:
  if (debug < 14) console.log(
    'firstLineLength', firstLineLength,
    'validSingleLine', validSingleLine,
    'validMultipleLines', validMultipleLines,
    // 'drawnCoordinates', dl,
    'currentStroke', cl
  );
  if (firstLineLength > 0) {
    deleteLastDrawnPointBtn.classList.remove('hidden');
    if (validSingleLine || validMultipleLines) ferdigBtn.classList.remove('hidden');
    else ferdigBtn.classList.add('hidden');
  } else {
    deleteLastDrawnPointBtn.classList.add('hidden');
    ferdigBtn.classList.add('hidden');
  }
}

export const enableEditButtons = () => {
  const waiting = (bar.style.display === 'block');
  const suitableResolution = map.getView().getResolution() < maxEditResolution;
  if (suitableResolution && editableRegion && !waiting) {
    // console.log('Activate buttons!');
    emphasise('geometry-change');
    emphasise('geometry-change-attributes');
    document.getElementById('toolbar_info').style.opacity = 1;
  } else { // too far from terrain or outside user's region
    // console.log('Deactivate buttons!');
    mitigate('geometry-change');
    mitigate('geometry-change-attributes');
    mitigate('toolbar_info');
  }
};

export function toggleTips() {
  const tips = document.getElementById('info-box-text-text');
  const h = tips.hidden;
  tips.hidden = !h;
  const newText = (h ? 'Skjul' : 'Vis') + ' tips'
  document.getElementById('hideLink').innerHTML = newText;
}
